import Swiper from "swiper/bundle";

export const iconsSldier = () => {
  const $iconSliders = document.querySelectorAll("section.icons-slider");
  $iconSliders.forEach(($iconSlider) => {
    const $iconSliderSwiper = $iconSlider.querySelector(
      ".icons-slider__content.swiper"
    );

    const $scrollBar = $iconSlider.querySelector(".swiper-scrollbar");
    if ($iconSliderSwiper && $scrollBar) {
      const slidesToShow = parseInt($iconSliderSwiper.dataset.slidesToShow) | 3;
      const swiperConfig = {
        direction: "horizontal",
        speed: 1000,
        slidesPerView: 2.1,
        spaceBetween: 12,
        centeredSlides: false,
        breakpoints: {
          768: {
            slidesPerView: Math.ceil(slidesToShow / 2),
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: slidesToShow,
            spaceBetween: 0,
          },
        },
        scrollbar: {
          el: $scrollBar,
          draggable: true,
          hide: false,
        },
      };
      const swiperObject = new Swiper($iconSliderSwiper, swiperConfig);
    }
  });
};

export default iconsSldier;
